import { ReturnRequestDto } from "@babackapp/private-api-client/types";

export function getFinancialDiscountChargesAmount(
  returnRequest: ReturnRequestDto,
  chargeForRefund?: boolean,
  chargeForInitialShipping?: boolean,
  forceRefundInitialShipping?: boolean,
) {
  let charges = 0;
  const fi = returnRequest.financial_informations;
  if (
    fi.return_shipping_paid?.method === "discount" &&
    fi.return_shipping_paid.presentment_amount > 0 &&
    chargeForRefund
  ) {
    charges += fi.return_shipping_paid.presentment_amount;
  }
  if (
    fi.initial_shipping_refunded?.method === "discount" &&
    fi.initial_shipping_refunded.presentment_amount > 0 &&
    chargeForInitialShipping &&
    !forceRefundInitialShipping
  ) {
    charges -= fi.initial_shipping_refunded.presentment_amount;
  }
  if (
    fi.initial_shipping_refunded?.method === "discount" &&
    fi.initial_shipping_refunded.presentment_amount === 0 &&
    forceRefundInitialShipping
  ) {
    charges -= fi.initial_shipping_refunded.sourceAmount;
  }
  return charges;
}
